import { render, staticRenderFns } from "./chronology.vue?vue&type=template&id=a45228a4&"
import script from "./chronology.vue?vue&type=script&lang=ts&"
export * from "./chronology.vue?vue&type=script&lang=ts&"
import style0 from "./chronology.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports